import { useShallow } from 'zustand/react/shallow';
import { useChallengeFormStore } from '../../NewChallengeForm.store';

export const usePurchaseDateTime = () => {
  return useChallengeFormStore(
    useShallow((s) => ({
      purchaseStartDate: s.challenge.purchaseStartDate,
      purchaseEndDate: s.challenge.purchaseEndDate,
    })),
  );
};

export const usePurchaseStartDateTimeActions = () => {
  const updateChallengeForm = useChallengeFormStore(
    (s) => s.updateChallengeForm,
  );

  const setPurchaseStartDateTime = (purchaseStartDate: string) =>
    updateChallengeForm({ purchaseStartDate });

  return { setPurchaseStartDateTime };
};
